import { FC, useMemo } from 'react'

import { isOut } from 'shared/utils/facts'

import { IFactsItemWrapperProps } from './FactsItemWrapper.props'

const FactsItemWrapper: FC<IFactsItemWrapperProps> = ({
  render,
  kpiItem: { fact, source },
  previousFact,
  peakFact,
  latestChart
}) => {
  const isOutdated = useMemo(() => isOut({ fact, source }, latestChart), [fact, source, latestChart])

  const isCurrentPeak = useMemo(
    () => !isOutdated && fact?.position_current && fact?.position_current === fact?.peak,
    [fact, isOutdated]
  )

  const isTrendable = useMemo(() => !!(fact?.position_last && fact?.position_current), [fact])

  const trend = useMemo(() => {
    if (!fact || !isTrendable) return

    const { position_current, position_last } = fact

    if (position_current < position_last) {
      return 'up'
    }
    if (position_current > position_last) {
      return 'down'
    }
  }, [fact, isTrendable])

  const isReEntry = useMemo(() => {
    if (isOutdated) return false

    return fact?.position_last === 0 && previousFact?.position_current
  }, [fact, isOutdated, previousFact])

  return render({
    fact,
    isOutdated,
    isCurrentPeak,
    isReEntry,
    trend,
    source,
    peakFact
  })
}

export default FactsItemWrapper
